module.exports = __webpack_public_path__ + "img/intro_sub_no.2b9b353f.svg";